import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { Subscription } from "rxjs";

// Constants
import { UserFlowTypes } from "src/app/constants/costants";

// Services
import { TranslationService } from "src/app/modules/shared/services/translation.service";
import { UserDetailsService } from "src/app/modules/user/services/user-details.service";
import { AccountService } from "src/app/modules/auth/services/account.service";
import { CommonService } from "src/app/modules/shared/services/common.service";
import { UtilityService } from "src/app/utility/utility.service";

@Component({
  selector: "app-preferences",
  templateUrl: "./preferences.component.html",
  styleUrls: ["./preferences.component.scss"],
})
export class PreferencesComponent implements OnInit, OnDestroy {
  subscriptionPreferenceForm = this.formBuilder.group({
    emailSubscribed: [false],
    mobileSubscribed: [false],
  });
  errorMessageText: string = "";
  emailId: string = "";
  mobileNumber: string = "";
  profileDetails;
  userDataSub: Subscription;
  updateSubscriptionPreSub: Subscription;
  getSubscriptionPreferenceSub: Subscription;
  UserFlowTypes: typeof UserFlowTypes;
  langCode: string;
  langCodeSubscription: Subscription;
  loader: any = {
    emailSubscription: { disable: false, sub: false },
    mobileSubcription: { disable: false, sub: false },
  };

  constructor(
    private utility: UtilityService,
    private formBuilder: FormBuilder,
    private accountService: AccountService,
    private userDetailsService: UserDetailsService,
    private commonService: CommonService,
    private translationService: TranslationService
  ) {
    this.UserFlowTypes = UserFlowTypes;
    this.langCode = this.utility.getLangCode();
    this.langCodeSubscription = this.translationService.langCodeSb$.subscribe(
      (langCode) => {
        this.langCode = langCode;
      }
    );
  }

  ngOnInit() {
    if (this.utility.isPnpFlow()) {
      this.getUserProfileData();
    }
    this.getSubscriptionPreference("");
  }

  getUserProfileData() {
    if (this.userDetailsService.getUserProfileDetails()) {
      this.profileDetails = this.userDetailsService.getUserProfileDetails();
      this.setUserDetails(this.profileDetails);
    } else {
      this.userDataSub = this.commonService.getUserData().subscribe((data) => {
        this.profileDetails = data;
        this.setUserDetails(this.profileDetails);
      });
    }
  }

  setUserDetails(profileData) {
    if (profileData) {
      this.emailId = profileData["email"];
      this.mobileNumber =
        "+" + profileData["cellPhoneAreaCode"] + profileData["cellPhone"];
    }
  }

  updateSubscriptionPreference(callingId) {
    this.togglePrferenceLoader(callingId, true);
    let data = this.utility.formControlToParams(
      this.subscriptionPreferenceForm,
      {}
    );
    this.updateSubscriptionPreSub = this.accountService
      .updateSubscriptionPreference(data)
      .subscribe((data) => {
        if (data && data["status"] === "SUCCESS") {
          this.getSubscriptionPreference(callingId);
        } else {
          if (callingId === "emailSubscription") {
            this.updateSubscriptionForm(
              !data["emailSubscribed"],
              data["mobileSubscribed"],
              callingId
            );
          } else {
            this.updateSubscriptionForm(
              data["emailSubscribed"],
              !data["mobileSubscribed"],
              callingId
            );
          }
          this.errorMessageText = this.translationService.instant(
            "preference.error_handle_msg"
          );
          setTimeout(() => {
            this.errorMessageText = undefined;
          }, 5000);
        }
      });
  }

  getSubscriptionPreference(callingId?) {
    this.togglePrferenceLoader(callingId, true);
    this.getSubscriptionPreferenceSub = this.accountService
      .getSubscriptionPreference()
      .subscribe((data) => {
        if (data && data["status"] == "SUCCESS") {
          this.updateSubscriptionForm(
            data["emailSubscribed"],
            data["mobileSubscribed"],
            callingId
          );
        } else {
          this.errorMessageText = this.translationService.instant(
            "preference.error_handle_msg"
          );
          setTimeout(() => {
            this.errorMessageText = undefined;
          }, 5000);
        }
      });
  }

  updateSubscriptionForm(emailStatus, mobileStatus, callingId?) {
    this.subscriptionPreferenceForm.controls["emailSubscribed"].setValue(
      emailStatus
    );
    this.subscriptionPreferenceForm.controls["mobileSubscribed"].setValue(
      mobileStatus
    );
    if (callingId) {
      this.togglePrferenceLoader(callingId, false);
    }
  }

  togglePrferenceLoader(callingId, isEnable) {
    if (isEnable && callingId) {
      this.loader[callingId]["sub"] = true;
      this.loader[callingId]["disable"] = true;
    } else if (callingId) {
      this.loader[callingId]["sub"] = false;
      this.loader[callingId]["disable"] = false;
    }
  }

  closeComponent(navigateTo?) {
    this.utility.closeAccountComponent(navigateTo);
  }

  ngOnDestroy() {
    if (this.userDataSub) {
      this.userDataSub.unsubscribe();
    }
    if (this.updateSubscriptionPreSub) {
      this.updateSubscriptionPreSub.unsubscribe();
    }
    if (this.getSubscriptionPreferenceSub) {
      this.getSubscriptionPreferenceSub.unsubscribe();
    }
  }
}
